import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getBaseUrl } from "../config";
import { getAuthApiHeaders } from "../../utils/common";
import { showSnackbar } from "./snackbar";
import secureLocalStorage from "react-secure-storage";

const baseUrl = getBaseUrl();

export const getLeadershipMetrics = createAsyncThunk(
  "leadershipMetrics/getLeadershipMetrics",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${baseUrl}/leadership`, {
        headers: {
          "Content-Type": "application/json",
          "use-case": "src",
          ...getAuthApiHeaders(),
          client: "UT",
        },
        withCredentials: true,
      });
      return response.data;
    } catch (error) {
      dispatch(showSnackbar({ message: "Failed to load!", severity: "error" }));
      return rejectWithValue(
        error?.response?.statusText || error.message || "Failed to load",
      );
    }
  },
  {
    // My Performance and the chat page's goals disclaimer both request this
    // on first load; one in-flight request serves both.
    condition: (_, { getState }) => !getState()?.leadershipMetrics?.isLoading,
  },
);

const leadershipMetricsSlice = createSlice({
  name: "leadership-metrics",
  initialState: {
    isLoading: false,
    metrics: {},
    isError: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLeadershipMetrics.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.isError = false;
        state.success = false;
      })
      .addCase(getLeadershipMetrics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.metrics = action.payload;
        state.success = true;
      })
      .addCase(getLeadershipMetrics.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export default leadershipMetricsSlice.reducer;
